import { isSupportedChainId } from 'lib/hooks/routing/clientSideSmartOrderRouter'
import {useAccount} from "wagmi";

export default function useAutoRouterSupported(): boolean {
  const { chainId } = useAccount()
  return isSupportedChainId(chainId)
}
